import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icon, { ICON_TYPE } from 'components/icon';
import { Anchor } from 'components/base';
import useCartContext from 'ecommerce/context/cart';
import useUserContext from 'ecommerce/context/user';
import BaseHeader from 'components/layout/header';

import SETTINGS from '../../settings';
import Nav from './nav';
import { CartPageLink, UserPageLink, SignInPageLink, HomePageLink } from '../pageLinks';

const Header = forwardRef((props, ref) => {
  const userContext = useUserContext();
  const cartContext = useCartContext();

  return (
    <BaseHeader
      ref={ref}
      topPosition={props.topPosition}
      showNavigation={props.showNavigation}
      left={
        <HomePageLink>
          <Anchor className="logo">
            <img src="/static/img/logo-mycanvas.svg" alt="MyCanvas" />
          </Anchor>
        </HomePageLink>
      }
      center={({ topPosition, navbarExpanded }) => (
        <Nav topPosition={topPosition} expanded={navbarExpanded} />
      )}
      right={
        <>
          {userContext.accessToken ? (
            <>
              <UserPageLink>
                <Anchor className="header-nav-link d-none d-md-block">MY&nbsp;ACCOUNT</Anchor>
              </UserPageLink>
              <UserPageLink>
                <Anchor className="text-body d-md-none">
                  <Icon type={ICON_TYPE.AVATAR} />
                </Anchor>
              </UserPageLink>
            </>
          ) : (
            <SignInPageLink>
              <Anchor className="header-nav-link">LOGIN</Anchor>
            </SignInPageLink>
          )}
          <CartPageLink>
            <Anchor className="link-bag">
              <Icon type={ICON_TYPE.CART} />
              {cartContext.length > 0 && (
                <span className="link-bag-count link-bag-count-mycanvas">{cartContext.length}</span>
              )}
            </Anchor>
          </CartPageLink>
          <Anchor className="text-body" href={SETTINGS.HELPDESK_URL} targetBlank>
            <Icon type={ICON_TYPE.HELP} />
          </Anchor>
        </>
      }
    />
  );
});

Header.propTypes = {
  showNavigation: PropTypes.bool,
  topPosition: PropTypes.number,
};

Header.defaultProps = {
  showNavigation: true,
  topPosition: 0,
};

export default Header;
